import React from "react";
import { Grid } from "@mui/material";
import SkillFrameworkItem from "./SkillFrameworkItem";

/**
 * フレームワーク / ライブラリ一覧表示
 *
 * - スマホ（xs）：1行に2つ
 * - タブレット以上（sm〜）：1行に4つ
 */
const SkillFrameworkList = ({ frameworks = [], owner }) => {
  return (
    <Grid container spacing={2} justifyContent="flex-start">
      {frameworks.map((fw) => (
        <Grid item key={fw.recordId || fw.displayName} xs={6} sm={3}>
          <SkillFrameworkItem framework={fw} owner={owner} />
        </Grid>
      ))}
    </Grid>
  );
};

export default SkillFrameworkList;
